(function () {
    try {
        const loaderTargets = document.querySelectorAll('[js-warm-lead-loader]');
        if (!loaderTargets || loaderTargets.length === 0) {
            return; 
        }

        const LOCAL_STORAGE_KEY = 'byob_warm_lead_dismissed';
        const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

        const dismissalTime = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (dismissalTime) {
            if (Date.now() - parseInt(dismissalTime, 10) < ONE_WEEK_MS) {
                console.log("Warm lead widget hidden via LocalStorage.");
                return; 
            } else {
                localStorage.removeItem(LOCAL_STORAGE_KEY);
            }
        }

        const referrer = document.referrer;
        if (!referrer || !referrer.includes(window.location.hostname) || !referrer.includes('/products/')) {
            return; 
        }

        const urlParts = referrer.split('/products/');
        if (urlParts.length < 2) return;
        const productHandle = urlParts[1].split('?')[0].split('#')[0].replace(/\/$/, "");

        if (!productHandle) return;

        const sectionId = 'suggested-product';
        const fetchUrl = `${window.Shopify.routes.root}?sections=${sectionId}&product_handle=${productHandle}`;

        fetch(fetchUrl)
        .then(response => response.json())
        .then(data => {
            const htmlContent = data[sectionId];
            if (!htmlContent || htmlContent.trim() === "") return;

            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlContent; 

            const mainWidgetMarkup = tempDiv.querySelector('.warm__lead__widget__main');
            
            if (mainWidgetMarkup) {
                loaderTargets.forEach((target, index) => {
                    const clone = mainWidgetMarkup.cloneNode(true);
                    clone.setAttribute('data-instance', index);
                    
                    target.innerHTML = '';
                    target.appendChild(clone);
                    
                    const outerNode = target.querySelector('[js-warm-lead-outer]');
                    if (outerNode) outerNode.classList.remove('hidden');
                });

                initWarmLeadDismissHandler(LOCAL_STORAGE_KEY);
            }
        })
        .catch(err => console.error("Error fetching dynamic suggested product:", err));

    } catch (error) {
        console.error("Warm lead widget execution failed safely:", error);
    }

    function initWarmLeadDismissHandler(storageKey) {
        document.body.addEventListener('click', function (e) {
            if (e.target.hasAttribute('js-destroy-warm-lead') || e.target.classList.contains('cta__with__rejection')) {
                e.preventDefault();
                localStorage.setItem(storageKey, Date.now().toString());
                const activeWidgets = document.querySelectorAll('.warm__lead__widget__main');
                activeWidgets.forEach(widget => {
                    widget.style.transition = 'opacity 0.3s ease';
                    widget.style.opacity = '0';
                    setTimeout(() => { widget.remove(); }, 300);
                });
            }
        });
    }
})(); 

document.addEventListener('DOMContentLoaded',()=>{
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const AUTOPLAY_DELAY = 3000;

    const heroMediaSlider = document?.querySelector('.collection__byob_twv__banner_nt.swiper');
    if (heroMediaSlider) {
        const customPagination = document.querySelector('.twv__banner__custom__pagination');
        const customNavPagOuter = document.querySelector(`.twv__banner__paginations`);
        let isPaused = false;

        function buildDots(count) {
            customPagination.innerHTML = '';
            for (let i = 0; i < count; i++) {
                const dot = document.createElement('div');
                dot.classList.add('dot');
                dot.style.setProperty('--autoplay-delay', AUTOPLAY_DELAY + 'ms');
                dot.addEventListener('click', () => swiperInstance.slideToLoop(i));
                customPagination.appendChild(dot);
            }
        }

        function setActiveDot(index, fillFull = false) {
            customPagination.querySelectorAll('.dot').forEach(dot => {
                dot.classList.remove('active', 'is-paused', 'is-filled');
                void dot.offsetWidth;
            });
            const activeDot = customPagination.querySelectorAll('.dot')[index];
            if (!activeDot) return;
            activeDot.classList.add('active');
            if (fillFull) {
                activeDot.classList.add('is-filled');
            }
        }

        const heroMediaSliderConfig = {
            spaceBetween: 0, slidesPerView: 1, grabCursor: true, speed: 300,
            navigation: {
                nextEl: heroMediaSlider.querySelector('.swiper-button-next'),
                prevEl: heroMediaSlider.querySelector('.swiper-button-prev')
            },
            autoplay: { delay: AUTOPLAY_DELAY, disableOnInteraction: true },
            loop: true,
            on: {
                autoplayStop() {
                    isPaused = true;
                    const activeDot = customPagination.querySelector('.dot.active');
                    if (activeDot) {
                        activeDot.classList.add('is-paused');
                    }
                },
                autoplayStart() {
                    isPaused = false;
                    const activeDot = customPagination.querySelector('.dot.active');
                    if (activeDot) {
                        activeDot.classList.remove('is-paused');
                    }
                },
                slideChangeTransitionEnd(swiper) {
                    setActiveDot(swiper.realIndex, isPaused);
                }
            }
        };

        if (!isIOS) {
            heroMediaSliderConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        }

        const swiperInstance = new Swiper(heroMediaSlider, heroMediaSliderConfig);
        const totalSlides = swiperInstance.slides.filter(
            s => !s.classList.contains('swiper-slide-duplicate')
        ).length;

        buildDots(totalSlides);
        setActiveDot(swiperInstance.realIndex);

        if (totalSlides <= 1) {
            if (customNavPagOuter) customNavPagOuter.classList.add(`hidden`);
            swiperInstance.autoplay.stop();
        }
    }

    const reviewsScrollarEl = document.querySelector('.page__reviews__swp.swiper');
    if (reviewsScrollarEl) {
        const reviewsScrollarConfig = { 
            spaceBetween: 12, slidesPerView: 'auto', grabCursor: true,
            navigation: { nextEl: reviewsScrollarEl.closest('.page__reviews__container').querySelector('.swiper-button-next'), prevEl: reviewsScrollarEl.closest('.page__reviews__container').querySelector('.swiper-button-prev')}
         };
        if (!isIOS) {
            reviewsScrollarConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
            reviewsScrollarConfig.freeMode = true;
        }
        new Swiper(reviewsScrollarEl, reviewsScrollarConfig);
    } 

    if ( document.querySelectorAll('.customer__testimonial_swipe').length > 0 ){
        const swiperElementCardSwp = document.querySelector('.customer__testimonial_swipe.swiper');
        if (swiperElementCardSwp) {
            const config = {
                spaceBetween: 12,allowTouchMove: true,slidesPerView: 'auto',grabCursor: true,keyboard: { enabled: true },
                navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'}
            };
            if (!isIOS) {
                config.freeMode = true;
                config.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
            }
            window.cardsSwiperInstance = new Swiper(swiperElementCardSwp, config);
        }  
    }

    if( document.querySelectorAll('.squeeze_scroller_item').length > 0 ){
        const scrollingContent = document.getElementById("scrollingContent");
        scrollingContent.innerHTML += scrollingContent.innerHTML;
        let x = 0;
        let scrollSpeed = 0.4;
        let isPaused = false;
        function animate() {
            if (!isPaused) {
            x -= scrollSpeed;
            if (Math.abs(x) >= scrollingContent.scrollWidth / 2) {
                x = 0;
            }
            scrollingContent.style.transform = `translateX(${x}px)`;
            }
            requestAnimationFrame(animate);
        }
        document.querySelector(".squeeze_scroller_main").addEventListener("mouseenter", () => isPaused = true);
        document.querySelector(".squeeze_scroller_main").addEventListener("mouseleave", () => isPaused = false);
        animate();  
    }  

    const bundleScripts = document.querySelectorAll('script[type="application/json"][id*="product_level"]');
    if( bundleScripts.length > 0 ){
        bundleScripts.forEach(script => {
            try {
                const items = JSON.parse(script.textContent);
                if (Array.isArray(items)) {
                    items.forEach(item => {
                        if (item.imageUrl) {
                            const imgCache = new Image();
                            imgCache.src = item.imageUrl;
                        }
                    });
                }
            } catch (e) {
                console.error("Preload caching skipped for item:", e);
            }
        });    
    }

    document?.querySelectorAll('a[href^="#"]').forEach(link => {
        link?.addEventListener('click', function (e) {
            const hash = this.getAttribute('href').slice(1);
            const target = document.querySelector(`[data-target-el="${hash}"]`);
            if (target) {
                e.preventDefault();
                const offset = document.querySelector(`.section-header`).clientHeight + document.querySelector('.this__sticky__nav__mn').clientHeight + 20;
                const top = target.getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({ top, behavior: 'smooth' });
            }
        });
    });    

    const updCommBuyButtonWMsg = () => {
        const drawerContainer = document.querySelector(`[js-drawer-communication-html]`);
        if (!drawerContainer) return;

        const eligibleInCart = drawerContainer.querySelectorAll(`[data-onetime-addons="false"]`).length;
        const addonsInCart = drawerContainer.querySelectorAll(`[data-onetime-addons="true"]`).length;
        const hasAddonsInCart = addonsInCart > 0;
        
        const totalItemsInCart = eligibleInCart + addonsInCart;

        const mainButton = document.querySelector(`[js-main-button]`);
        const mainButtonText = mainButton?.querySelector(`[js-main-button-text]`);
        const limitItemsElements = document.querySelectorAll(`[js-drawer-limit-items]`);
        const totalCountElements = document.querySelectorAll(`[js-cm-count-items-total]`);
        const warningNotice = document.querySelector(`[js-drawer-notice--warn]`);
        const carekitItems = document.querySelectorAll(`.addons___carekit_item`);

        totalCountElements?.forEach((el) => { 
            el.hasAttribute(`has-selected`) 
                ? (el.textContent = `${totalItemsInCart} Selected`) 
                : (el.textContent = totalItemsInCart); 
        });

        if (eligibleInCart >= 3) {
            if (warningNotice) warningNotice.classList.add('hidden');
            carekitItems?.forEach((item) => {
                item.classList.remove('disabled_meanwhile');
            });

            if (mainButtonText) mainButtonText.textContent = `Add to Cart (${totalItemsInCart} items)`;
            if (mainButton) mainButton.disabled = false;
            
            limitItemsElements?.forEach((el) => { 
                if (!el.hasAttribute(`js-mb-drawer-limit-items`)) { 
                    el.classList.remove('hidden'); 
                    el.textContent = `Add items +`;
                } 
            });
        } else {
            carekitItems?.forEach((item) => {
                item.classList.add('disabled_meanwhile');
            });
            
            if (warningNotice) {
                if (hasAddonsInCart) {
                    warningNotice.classList.remove('hidden');
                } else {
                    warningNotice.classList.add('hidden');
                }
            }

            const itemsNeeded = 3 - eligibleInCart;
            const itemWord = itemsNeeded === 1 ? 'item' : 'items';
            
            const messageText = hasAddonsInCart 
                ? `Add ${itemsNeeded} eligible ${itemWord} to checkout`
                : `Add ${itemsNeeded} ${itemWord} to checkout`;
            
            if (mainButtonText) mainButtonText.textContent = messageText;
            if (mainButton) mainButton.disabled = true;
            
            limitItemsElements?.forEach((el) => { 
                el.classList.remove('hidden', 'highlight'); 
                el.textContent = `${messageText} +`;
            });
        }
    };

    const updCommItemAdd = (targetEl) => {
        const bundleGroupId = "group-" + Date.now() + "-" + Math.floor(Math.random() * 1000);
        let mapChildBundle = targetEl.dataset.productTarget;
        let itemsHtmlToAppend = "";
        const scriptElement = targetEl.querySelector(`[id="${mapChildBundle}"]`);
        const isOneTime = document?.querySelector('input[name="purchaseType"]:checked')?.value === 'purchaseTypeOneTime';
        
        if (scriptElement) {
            try {
                const bundleItems = JSON.parse(scriptElement.textContent);

                bundleItems.forEach(item => {
                    let displayPrice = isOneTime ? item.priceFormatted : (item.SubscribePriceFormatted || item.priceFormatted);
                    let displayCPrice = isOneTime ? item.compareAtPriceFormatted : (item.SubscribeCompareAtPriceFormatted || item.compareAtPriceFormatted);
                    let loopCount = parseInt(item.quantity) || 1;

                    for (let i = 0; i < loopCount; i++) {
                        itemsHtmlToAppend += buildItemHtml(targetEl, {
                            title: item.productTitle,
                            price: item.priceFormatted,
                            subPrice: item.SubscribePriceFormatted || '',
                            cprice: item.compareAtPriceFormatted,
                            subCprice: item.SubscribeCompareAtPriceFormatted || '',
                            variantId: item.id,
                            imageUrl: item.imageUrl,
                            displayPrice: displayPrice,
                            displayCPrice: displayCPrice,
                            bundleGroupId: bundleGroupId,
                            serving: item.serving,
                            selling_plan_id: item.selling_plan_id,
                            dynamicBoxid: item.dynamic_box_id
                        });
                    }
                });
            } catch (e) {
                console.error("Error parsing product bundle JSON:", e);
            }
        } else {
            let displayPrice = isOneTime ? targetEl?.dataset?.productPrice : (targetEl?.dataset?.productsubscripitonPrice || targetEl?.dataset?.productPrice);
            let displayCPrice = isOneTime ? targetEl?.dataset?.productCprice : (targetEl?.dataset?.productsubscripitonCprice || targetEl?.dataset?.productCprice);

            itemsHtmlToAppend += buildItemHtml(targetEl, {
                title: targetEl?.dataset?.productTitle,
                price: targetEl?.dataset?.productPrice,
                subPrice: targetEl?.dataset?.productsubscripitonPrice || '',
                cprice: targetEl?.dataset?.productCprice,
                subCprice: targetEl?.dataset?.productsubscripitonCprice || '',
                variantId: targetEl?.dataset?.productVariantId,
                imageUrl: targetEl?.dataset?.productImage,
                displayPrice: displayPrice,
                displayCPrice: displayCPrice,
                bundleGroupId: bundleGroupId
            });
        }

        if(itemsHtmlToAppend !== "") {
            const communicationDrawer = document.querySelector('[js-drawer-communication-html]');
            if(communicationDrawer) {
                communicationDrawer.innerHTML = communicationDrawer.innerHTML + itemsHtmlToAppend;
            }
        }

        updCommBuyButtonWMsg();
        SummaryDrawerMobileAnimation();
        updCommPriceTotal();
    }

    const buildItemHtml = (targetEl, data) => {
        const cleanPrice = (priceStr) => {
            if (!priceStr) return 0;
            return parseFloat(priceStr.replace(/[^0-9.-]+/g, "")) || 0;
        };
        const numericPrice = cleanPrice(data.displayPrice);
        const numericCPrice = cleanPrice(data.displayCPrice);
        const numericSubPrice = cleanPrice(data.subPrice);
        const isOneTime = document?.querySelector('input[name="purchaseType"]:checked')?.value === 'purchaseTypeOneTime';

        let shouldShowComparePrice = false;
        let fallbackComparePrice = data.displayCPrice;

        if (!isOneTime) {
            if (numericCPrice > 0 && numericCPrice > numericPrice && numericCPrice > numericSubPrice) {
                shouldShowComparePrice = true;
            } else {
                shouldShowComparePrice = true;
                fallbackComparePrice = data.price;
            }
        } else {
            if (numericCPrice > numericPrice) {
                shouldShowComparePrice = true;
            } else {
                shouldShowComparePrice = false;
            }
        }


        targetEl?.hasAttribute(`js-has-onetime-only`) ? (shouldShowComparePrice = false) : (shouldShowComparePrice = shouldShowComparePrice );

        const cPriceClass = shouldShowComparePrice ? "" : "hidden";
        const PriceClass = shouldShowComparePrice ? "" : "normal__price__color";
        const displayServingText = data.serving || targetEl?.dataset?.servingProcess || '';
        const sellingPlanIdMap = data.selling_plan_id || targetEl?.dataset?.productSellingId || '';
        const dynamicBoxIdMap = data.dynamicBoxid || targetEl?.dataset?.productDynamicboxId || '';

        return `
        <div class="dproute__product__item" js-cm-drawer-outer
            data-bundle-group-id="${data.bundleGroupId}" 
            data-onetime-addons="${ targetEl?.hasAttribute(`js-has-onetime-only`) ? `true` : `false` }" 
            data-restrictions-has="${ targetEl?.hasAttribute(`js-restrictions-for-adding`) ? `true` : `false` }"
            data-accepts-onetime="${ targetEl?.hasAttribute(`js-has-onetime-only`) ? `true` : `false` }"  
            data-mapped-target="${targetEl?.dataset?.productTarget}"
            data-mapped-handle="${data.title}"
            data-mapped-price="${data.price}" 
            data-mapped-subscription-price="${data.subPrice}"
            data-mapped-cprice="${data.cprice}" 
            data-mapped-subscription-cprice="${fallbackComparePrice}"
            data-mapped-variant-id="${data.variantId}"
            data-mapped-selling-id="${sellingPlanIdMap}"
            data-mapped-dynamicbox-id="${dynamicBoxIdMap}">
            
            <div class="dproute_image_drawer"><img src="${data.imageUrl}"></div>
            <div class="dproute_content_drawer">
                <div class="dproute_title_priceContainer">
                    <div class="dproute_title_drawer">${data.title}</div>
                    <div class="dproute_price_drawerMn">
                        <span class="dproute_price_drawer ${PriceClass}" js-cm-drawer-price>${data.displayPrice}</span>
                        <span class="dproute_cprice_drawer ${cPriceClass}" js-cm-drawer-cprice>${fallbackComparePrice}</span>
                    </div>
                </div>
                <div class="dproute_servingRemoveContainer">
                    <div class="dproute_serving_drawer">${displayServingText}</div>
                    <div class="dproute_remove_drawer" js-cm-drawer-remove>
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                            <path d="M5.16497 16.625C4.83841 16.625 4.55885 16.5087 4.3263 16.2762C4.09375 16.0436 3.97747 15.7641 3.97747 15.4375V4.15625H3.16602V2.96875H6.88685V2.375H12.1118V2.96875H15.8327V4.15625H15.0212V15.4375C15.0212 15.7542 14.9025 16.0312 14.665 16.2688C14.4275 16.5062 14.1504 16.625 13.8337 16.625H5.16497ZM13.8337 4.15625H5.16497V15.4375H13.8337V4.15625ZM7.26289 13.7354H8.45039V5.83854H7.26289V13.7354ZM10.5483 13.7354H11.7358V5.83854H10.5483V13.7354Z" fill="#797B7A"></path>
                        </svg>
                    </div>
                </div>
                <div class="dproute__form-title ${ (targetEl?.hasAttribute(`js-has-onetime-only`) || targetEl?.hasAttribute(`js-main-bundle-group`)) ? `hidden` : ` ` }">
                    <div class="dproute_bannerKeyPoints">
                        ${(() => {
                            const offers = targetEl?.dataset?.productOffer ? targetEl.dataset.productOffer.split('|').filter(o => o.trim() !== '') : [];
                            if (!offers.length) return '';
                            return offers.map(offer => `
                                <div class="dproute_bannerKeyPoint">
                                    <span class="KyIcon__dproute">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="m.467 6.41 4.46 4.573 7.673-8.4" stroke="#398200" stroke-width="1.167"></path></svg>
                                    </span>
                                    <span class="KyPoint__dproute">${offer.trim()}</span>
                                </div>
                            `).join('');
                        })()}
                    </div>
                </div>
                ${ targetEl?.hasAttribute(`js-has-onetime-only`) ? `<div class="has__onetime__only"><span>Add-On Item</span></div>` : ` ` }                
            </div>
        </div>`;
    }

    const updCommItemRemove = (targetEl, fromDrawer) => {
        const drawerContainer = document.querySelector('[js-drawer-communication-html]');
        if (!drawerContainer) return;

        if (fromDrawer) {
            const groupId = targetEl.getAttribute('data-bundle-group-id');
            const mappedTarget = targetEl.dataset.mappedTarget;
            targetEl.remove();
            const remainingInGroup = drawerContainer.querySelectorAll(`[data-bundle-group-id="${groupId}"]`).length;
            const dashboardItem = document.querySelector(`[data-product-target="${mappedTarget}"]`);
            
            if (dashboardItem) {
                const qtyInput = dashboardItem.querySelector('[js-button-confiq-input]');
                
                if (remainingInGroup === 0) {
                    let currentQty = parseInt(qtyInput.textContent || "1", 10);
                    if (currentQty <= 1) {
                        dashboardItem.querySelector(`[js-button-confiq-outer]`)?.classList.remove('active');
                        qtyInput.innerHTML = 1;
                    } else {
                        currentQty = currentQty - 1;
                        qtyInput.innerHTML = currentQty;
                        if (currentQty === 1) {
                            dashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.remove('hidden');
                            dashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.add('hidden');
                        }
                    }
                } else {
                    const totalMatchingItems = drawerContainer.querySelectorAll(`.dproute__product__item[data-mapped-target="${mappedTarget}"]`).length;
                    const dynamicQty = Math.ceil(totalMatchingItems / 3);
                    qtyInput.innerHTML = dynamicQty > 0 ? dynamicQty : 1;

                    if (dynamicQty === 1) {
                        dashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.remove('hidden');
                        dashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.add('hidden');
                    } else {
                        dashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.add('hidden');
                        dashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.remove('hidden');
                    }
                }
            }
        } else {
            const productTarget = targetEl.dataset.productTarget;
            const matchingDrawerItems = drawerContainer.querySelectorAll(`.dproute__product__item[data-mapped-target="${productTarget}"]`);
            
            if (matchingDrawerItems.length > 0) {
                const lastItem = matchingDrawerItems[matchingDrawerItems.length - 1];
                const lastGroupId = lastItem.getAttribute('data-bundle-group-id');
                const elementsToRemove = drawerContainer.querySelectorAll(`[data-bundle-group-id="${lastGroupId}"]`);
                elementsToRemove.forEach(el => el.remove());
            }
        }

        if (typeof updCommBuyButtonWMsg === 'function') updCommBuyButtonWMsg();
        if (typeof updCommPriceTotal === 'function') updCommPriceTotal();
    };

    const clearAllCommHTMLAndResetDashboard = () => {
        const drawerContainer = document.querySelector('[js-drawer-communication-html]');
        if (!drawerContainer) return;
        drawerContainer.innerHTML = '';
        const activeDashboardItems = document.querySelectorAll('[data-product-target]');
        activeDashboardItems.forEach((dashboardItem) => {
            dashboardItem.querySelector(`[js-button-confiq-outer]`)?.classList.remove('active');
            const qtyInput = dashboardItem.querySelector('[js-button-confiq-input]');
            if (qtyInput) {
                qtyInput.innerHTML = 1;
            }
            dashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.remove('hidden');
            dashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.add('hidden');
        });

        if( document.querySelector(`[js-cm-main-outer-stepper]`).querySelectorAll(`.for__step__one`).length > 0 ){
            document.querySelector(`[js-cm-main-outer-stepper]`).querySelector(`.for__step__second`).classList.remove('active');
            document.querySelector(`[js-cm-main-outer-stepper]`).querySelector(`.for__step__one`).classList.remove('hidden');
            document?.querySelector(`.twv__split___renders__drawer`)?.classList?.remove(`stepper__procced`);
        }

        updCommBuyButtonWMsg();
        updCommPriceTotal();
    };


    const updPriceAllOverPSelBased = (PurchaseType)=>{
        if( PurchaseType == 'purchaseTypeOneTime' ){
            document.querySelectorAll(`[js-main-item-outer]`).forEach((el) => {
                let targetElProduct = el.dataset.productTarget;
                let oneTimePrice = el.dataset.productPrice;
                let oneTimeCPrice = el.dataset.productCprice;
                if( el?.querySelector(`[js-item-product-price]`) || el?.querySelector(`[js-item-product-cprice]`) ){
                    el.querySelector(`[js-item-product-price]`).textContent = oneTimePrice;
                    el.querySelector(`[js-item-product-cprice]`).textContent = oneTimeCPrice;
                    const priceVal  = parseFloat(oneTimePrice.replace(/[^0-9.]/g, ''));
                    const cPriceVal = parseFloat(oneTimeCPrice.replace(/[^0-9.]/g, ''));
                    if (cPriceVal > priceVal) {
                        el?.querySelector(`[js-item-product-cprice]`)?.classList?.remove('hidden');
                        el?.querySelector(`[js-item-product-price]`)?.classList?.remove('normal__price__color');
                    } else {
                        el?.querySelector(`[js-item-product-cprice]`)?.classList?.add('hidden');
                        el?.querySelector(`[js-item-product-price]`)?.classList?.add('normal__price__color');
                    }
                    document?.querySelectorAll(`[data-mapped-target="${targetElProduct}"]`)?.forEach((dEl) => {
                        dEl.querySelector(`[js-cm-drawer-price]`).textContent = dEl.dataset.mappedPrice;
                        dEl.querySelector(`[js-cm-drawer-cprice]`).textContent = dEl.dataset.mappedCprice;
                        if (cPriceVal > priceVal) {
                            dEl?.querySelector(`[js-cm-drawer-cprice]`)?.classList?.remove('hidden');
                            dEl?.querySelector(`[js-cm-drawer-price]`)?.classList?.remove('normal__price__color');
                        } else {
                            dEl?.querySelector(`[js-cm-drawer-cprice]`)?.classList?.add('hidden');
                            dEl?.querySelector(`[js-cm-drawer-price]`)?.classList?.add('normal__price__color');
                        }                    
                    });
                }
            });          
        }else{
            document.querySelectorAll(`[js-main-item-outer]`).forEach((el) => {
                let targetElProduct = el.dataset.productTarget;
                let SubscribePrice = el.dataset.productsubscripitonPrice;
                let SubscribeCPrice = el.dataset.productsubscripitonCprice;
                if( el?.querySelector(`[js-item-product-price]`) || el?.querySelector(`[js-item-product-cprice]`) ){
                    el.querySelector(`[js-item-product-price]`).textContent = SubscribePrice;
                    el.querySelector(`[js-item-product-cprice]`).textContent = SubscribeCPrice;
                    const priceVal  = parseFloat(SubscribePrice.replace(/[^0-9.]/g, ''));
                    const cPriceVal = parseFloat(SubscribeCPrice.replace(/[^0-9.]/g, ''));
                    if (cPriceVal > priceVal) {
                        el?.querySelector(`[js-item-product-cprice]`)?.classList?.remove('hidden');
                        el?.querySelector(`[js-item-product-price]`)?.classList?.remove('normal__price__color');
                    } else {
                        el?.querySelector(`[js-item-product-cprice]`)?.classList?.add('hidden');
                        el?.querySelector(`[js-item-product-price]`)?.classList?.add('normal__price__color');
                    }
                    document?.querySelectorAll(`[data-mapped-target="${targetElProduct}"]`)?.forEach((dEl) => {
                        dEl.querySelector(`[js-cm-drawer-price]`).textContent = dEl.dataset.mappedSubscriptionPrice;
                        dEl.querySelector(`[js-cm-drawer-cprice]`).textContent = dEl.dataset.mappedSubscriptionCprice;
                        if (cPriceVal > priceVal) {
                            dEl?.querySelector(`[js-cm-drawer-cprice]`)?.classList?.remove('hidden');
                            dEl?.querySelector(`[js-cm-drawer-price]`)?.classList?.remove('normal__price__color');
                        } else {
                            dEl?.querySelector(`[js-cm-drawer-cprice]`)?.classList?.add('hidden');
                            dEl?.querySelector(`[js-cm-drawer-price]`)?.classList?.add('normal__price__color');
                        }                    
                    });
                }
            });            
        }
    }

    const updCommPriceTotal = () => {
        let totalOneTimePrice   = 0;
        let totalOneTimeCprice  = 0;
        let totalSubscribePrice = 0;
        let totalSubscribeCprice = 0;

        document?.querySelectorAll(`[js-cm-drawer-outer]`)?.forEach((item) => {
            let itemOnetimePrice      = item.dataset.mappedPrice;
            let itemOnetimeCprice     = item.dataset.mappedCprice;
            let itemSubscribePrice    = item.dataset.mappedSubscriptionPrice || itemOnetimePrice;
            let itemSubscribeCprice   = item.dataset.mappedSubscriptionCprice || itemOnetimeCprice;
            const parsePrice = (val) => {
                if (!val) return 0;
                return parseFloat(val.toString().replace(/[^0-9.]/g, '')) || 0;
            };
            totalOneTimePrice    += parsePrice(itemOnetimePrice);
            totalOneTimeCprice   += parsePrice(itemOnetimeCprice);
            totalSubscribePrice  += parsePrice(itemSubscribePrice);
            totalSubscribeCprice += parsePrice(itemSubscribeCprice);
        });

        const fmt = (val) => val === 0 ? '' : `$${val.toFixed(2)}`;

        if (document?.querySelector(`[js-onetimeprice]`) || document?.querySelector(`[js-subscribeprice]`)) {
            document.querySelector(`[js-onetimeprice]`).textContent  = fmt(totalOneTimePrice);
            document.querySelector(`[js-onetimecprice]`).textContent = fmt(totalOneTimeCprice);
            document.querySelector(`[js-subscribeprice]`).textContent  = fmt(totalSubscribePrice);
            document.querySelector(`[js-subscribecprice]`).textContent = fmt(totalSubscribeCprice);
            if (totalOneTimeCprice > totalOneTimePrice) {
                document?.querySelector(`[js-onetimeprice]`)?.classList.add(`this__cprice`);
                document?.querySelector(`[js-onetimecprice]`)?.classList.remove(`hidden`);
            } else {
                document?.querySelector(`[js-onetimeprice]`)?.classList.remove(`this__cprice`);
                document?.querySelector(`[js-onetimecprice]`)?.classList.add(`hidden`);
            }
            if (totalSubscribeCprice > totalSubscribePrice) {
                document?.querySelector(`[js-subscribeprice]`)?.classList.add(`this__cprice`);
                document?.querySelector(`[js-subscribecprice]`)?.classList.remove(`hidden`);
            } else {
                document?.querySelector(`[js-subscribeprice]`)?.classList.remove(`this__cprice`);
                document?.querySelector(`[js-subscribecprice]`)?.classList.add(`hidden`);
            }
        }
        updCommProgressBar();
        updCmDrawerUpsellMessage();
    };

    const updCommProgressBar = ()=>{
        const checkedPurchaseType = document.querySelector(`input[name="purchaseType"]:checked`)?.value;
        const priceSelectorOneTime = `[js-onetimeprice]`;
        const priceSelectorSubscribe = `[js-subscribeprice]`;
        const priceSelector = checkedPurchaseType === 'purchaseTypeOneTime'
            ? `[js-onetimeprice]`
            : `[js-subscribeprice]`;
        const priceText = document.querySelector(priceSelector)?.textContent?.trim();
        const currentPrice = priceText ? parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0 : 0;
        const priceTextOneTime = document.querySelector(priceSelectorOneTime)?.textContent?.trim();
        const currentPriceOneTime = priceTextOneTime ? parseFloat(priceTextOneTime.replace(/[^0-9.]/g, '')) || 0 : 0;
        const priceTextSubscribe = document.querySelector(priceSelectorSubscribe)?.textContent?.trim();
        const currentPriceSubscribe = priceTextSubscribe ? parseFloat(priceTextSubscribe.replace(/[^0-9.]/g, '')) || 0 : 0;                
        document?.querySelectorAll(`[js-cm-progress-bar]`)?.forEach((bar) => {
            const threshold = parseFloat(bar.dataset.thresholdBar) || 0;
            if (!currentPrice || !threshold) {
                checkedPurchaseType === 'purchaseTypeOneTime' ?
                ( bar.querySelector(`[js-progress-cm-width]`).style.width = '0%',bar.querySelector(`[js-cm-bar-ongoing]`).classList.remove(`hidden`),bar.querySelector(`[js-cm-bar-success]`).classList.add(`hidden`),bar.querySelector(`[js-cm-bar-ongoing]`).innerHTML = bar.querySelector(`[js-cm-bar-ongoing]`).dataset.priceMessage ):
                ( bar.hasAttribute(`js-with-drawer-shipping`) ? ( bar.querySelector(`[js-progress-cm-width]`).style.width = '100%',bar.querySelector(`[js-cm-bar-ongoing]`).classList.add(`hidden`),bar.querySelector(`[js-cm-bar-success]`).classList.remove(`hidden`) ) : (bar.querySelector(`[js-progress-cm-width]`).style.width = '0%',bar.querySelector(`[js-cm-bar-ongoing]`).innerHTML = bar.querySelector(`[js-cm-bar-ongoing]`).dataset.priceMessage) )
                return;
            }
            const widthPercent = Math.min((currentPrice / threshold) * 100, 100);
            checkedPurchaseType === 'purchaseTypeOneTime' ?
                ( bar.querySelector(`[js-progress-cm-width]`).style.width = `${widthPercent.toFixed(2)}%` ) :
                ( bar.hasAttribute(`js-with-drawer-shipping`) ? ( bar.querySelector(`[js-progress-cm-width]`).style.width = '100%' ) : ( bar.querySelector(`[js-progress-cm-width]`).style.width = `${widthPercent.toFixed(2)}%` ) );
            const remaining = Math.max(threshold - currentPrice, 0);
            checkedPurchaseType === 'purchaseTypeOneTime' ?
                (bar.hasAttribute(`js-with-drawer-shipping`) ? ( bar.querySelector(`[js-cm-bar-ongoing]`).classList.remove(`hidden`),bar.querySelector(`[js-cm-bar-success]`).classList.add(`hidden`),bar.querySelector(`[js-cm-bar-ongoing]`).innerHTML = `$${remaining.toFixed(2)} away from free shipping` ) : ( bar.querySelector(`[js-cm-bar-ongoing]`).innerHTML = `$${remaining.toFixed(2)} away from free gift` )) :
                (bar.hasAttribute(`js-with-drawer-shipping`) ? ( bar.querySelector(`[js-cm-bar-ongoing]`).classList.add(`hidden`),bar.querySelector(`[js-cm-bar-success]`).classList.remove(`hidden`) ) : ( bar.querySelector(`[js-cm-bar-ongoing]`).innerHTML = `$${remaining.toFixed(2)} away from free gift` ));
                bar.setAttribute('data-current-value',`$${remaining.toFixed(2)}`);
            if (widthPercent >= 100) {
                bar.querySelector(`[js-cm-bar-success]`)?.classList.remove('hidden');
                bar.querySelector(`[js-cm-bar-ongoing]`)?.classList.add('hidden');
            } else {
                checkedPurchaseType === 'purchaseTypeOneTime' ?
                ( bar.querySelector(`[js-cm-bar-success]`)?.classList.add('hidden'),bar.querySelector(`[js-cm-bar-ongoing]`)?.classList.remove('hidden') ) :
                ( bar.hasAttribute(`js-with-drawer-shipping`) ? (bar.querySelector(`[js-cm-bar-success]`)?.classList.remove('hidden'),bar.querySelector(`[js-cm-bar-ongoing]`)?.classList.add('hidden')) : (bar.querySelector(`[js-cm-bar-success]`)?.classList.add('hidden'),bar.querySelector(`[js-cm-bar-ongoing]`)?.classList.remove('hidden')) );
            }       
        }); 

        let thresholdShipping = parseFloat(document.querySelector(`[js-with-drawer-shipping]`).dataset.thresholdBar) || 0;
        let thresholdFreeGifts = parseFloat(document.querySelector(`[js-with-drawer-gifts]`).dataset.thresholdBar) || 0;
        if ( currentPriceOneTime >= thresholdShipping ) {
            document?.querySelectorAll(`.product_route__shipping_txt`)?.forEach((ships)=>{ ships.classList.add('hidden'); })
            document?.querySelectorAll(`[js-cm-shipping-eligible]`)?.forEach((ships)=>{ ships.classList.remove('hidden'); })
        }else{
            document?.querySelectorAll(`.product_route__shipping_txt`)?.forEach((ships)=>{ ships.classList.remove('hidden'); })
            document?.querySelectorAll(`[js-cm-shipping-eligible]`)?.forEach((ships)=>{ ships.classList.add('hidden'); })
        }                
        if ( currentPriceSubscribe >= thresholdFreeGifts ) {
            document?.querySelectorAll(`[js-cm-gifts-eligible]`)?.forEach((ships)=>{ ships.classList.remove('hidden'); })
        }else{
            document?.querySelectorAll(`[js-cm-gifts-eligible]`)?.forEach((ships)=>{ ships.classList.add('hidden'); })
        }                

        if( document.querySelector(`[js-drawer-communication-html]`).childElementCount > 2 ){
            if( (parseFloat(document?.querySelector(`[js-with-drawer-shipping]`)?.querySelector(`[js-progress-cm-width]`)?.style?.width) < 100) && (checkedPurchaseType == 'purchaseTypeOneTime') ){
                let ShippingTextMsg = document?.querySelector(`.product__includes_bar.product__includes_bar__shipping`)?.querySelector(`.product__includes_bar__texts`)?.querySelector(`[js-cm-bar-ongoing]`)?.textContent;
                document?.querySelectorAll(`[js-mb-drawer-limit-items]`)?.forEach((el)=>{ el.classList.add('highlight'); el.textContent = `${ShippingTextMsg}` });
            }else if( parseFloat(document?.querySelector(`[js-with-drawer-gifts]`)?.querySelector(`[js-progress-cm-width]`)?.style?.width) < 100 ){
                let GiftsTextMsg = document?.querySelector(`.product__includes_bar.product__includes_bar__gifts`)?.querySelector(`.product__includes_bar__texts`)?.querySelector(`[js-cm-bar-ongoing]`)?.textContent;
                document?.querySelectorAll(`[js-mb-drawer-limit-items]`)?.forEach((el)=>{ el.classList.add('highlight'); el.textContent = `${GiftsTextMsg}` });                          
            }else{
                document?.querySelectorAll(`[js-mb-drawer-limit-items]`)?.forEach((el)=>{ el.classList.add('highlight'); el.innerHTML = `<span class="product__includes_bar_msg_icon"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M1 7.1 5.78 12 14 3" stroke="#398200" stroke-width="1.25"></path></svg></span> <span class="product__includes_bar_msg_txt">Free gift</span>` });                    
            }
        }        
    }

    const updCmDrawerUpsellMessage = ()=>{
        const checkedPurchaseTypeEl = document.querySelector(`input[name="purchaseType"]:checked`)?.value;
        if( (checkedPurchaseTypeEl === 'purchaseTypeOneTime') && (parseFloat(document?.querySelector(`[js-with-drawer-shipping]`)?.querySelector(`[js-progress-cm-width]`)?.style?.width) < 100) ){
            let currentValue = document?.querySelector(`[js-with-drawer-shipping]`).dataset.currentValue;
            document.querySelector(`[js-upsell-shipping-remaining-amt-outer]`).innerHTML = `Add ${currentValue} to get free shipping on your order.`;
        }else if( (checkedPurchaseTypeEl === 'purchaseTypeOneTime') && (parseFloat(document?.querySelector(`[js-with-drawer-gifts]`)?.querySelector(`[js-progress-cm-width]`)?.style?.width) < 100) ){
            let currentValue = document?.querySelector(`[js-with-drawer-gifts]`).dataset.currentValue;
            document.querySelector(`[js-upsell-shipping-remaining-amt-outer]`).innerHTML = `Add ${currentValue} to get a free $24 gift on your order.`;
        }else if( (checkedPurchaseTypeEl === 'purchaseTypeSubscription') && (parseFloat(document?.querySelector(`[js-with-drawer-gifts]`)?.querySelector(`[js-progress-cm-width]`)?.style?.width) < 100) ){
            let currentValue = document?.querySelector(`[js-with-drawer-gifts]`).dataset.currentValue;
            document.querySelector(`[js-upsell-shipping-remaining-amt-outer]`).innerHTML = `Add ${currentValue} to get a free $24 gift on your order.`;
        }else{
            document.querySelector(`[js-upsell-shipping-remaining-amt-outer]`).innerHTML = `Round out your routine and save.`;
        }
        if( checkedPurchaseTypeEl === 'purchaseTypeOneTime' ){
            document?.querySelector(`[js-upsell-message-outer]`)?.classList.add(`hidden`);
        }else{
            document?.querySelector(`[js-upsell-message-outer]`)?.classList.remove(`hidden`);
        }
    }

    const SummaryDrawerMobileAnimation = (() => {
        let animationTimeout = null;
        return () => {
            const el = document.querySelector('[js-cm-drawer-mb-closed-bar-outer]');
            if (!el) return;
            if (animationTimeout) {
                clearTimeout(animationTimeout);
                animationTimeout = null;
            }
            el.classList.remove('bouncing');
            void el.offsetWidth;
            el.classList.add('bouncing');
            animationTimeout = setTimeout(() => {
                el.classList.remove('bouncing');
                animationTimeout = null;
            }, 1500);
        };
    })();

    const getGuid = ()=> {
        let d = new Date().getTime();
        let d2 =  (performance && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            let r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c == 'x' ? r: (r & 0x7 | 0x8)).toString(16);
        }); 
    }

    const stickyNavBuildScroll = () => {
        var navLabels   = document.querySelectorAll('.twv__sticky__naviagtion_label');
        var sections    = document.querySelectorAll('[js-scroll-section]');
        var header      = document.querySelector('.section-header');
        var stk__nave   = document.querySelector('.this__sticky__nav__mn');
        var navScroller = document.querySelector('.twv__sticky__naviagtion_wp');
        var ticking     = false;
        var resizeTimer = null;
        if (!navLabels.length || !sections.length) return;
        function getOffsetTop(el) {
            var top = 0;
            while (el) {
                top += el.offsetTop;
                el   = el.offsetParent;
            }
            return top;
        }
        function clearAll() {
            for (var j = 0; j < navLabels.length; j++) {
                navLabels[j].classList.remove('active');
            }
        }
        function findNavMatch(targetVal) {
            if (!targetVal) return null;
            for (var k = 0; k < navLabels.length; k++) {
                var linkTarget = navLabels[k].getAttribute('href');
                linkTarget     = linkTarget ? linkTarget.replace('#', '') : '';
                if (linkTarget === targetVal) {
                    return navLabels[k];
                }
            }
            return null;
        }
        function scrollToActiveNav(activeLabel) {
            if (!navScroller || !activeLabel) return;
            var navScrollerRect = navScroller.getBoundingClientRect();
            var activeLabelRect = activeLabel.getBoundingClientRect();
            var labelCenter    = activeLabelRect.left + activeLabelRect.width / 2;
            var scrollerCenter = navScrollerRect.left + navScrollerRect.width / 2;
            var scrollOffset   = navScroller.scrollLeft + (labelCenter - scrollerCenter);
            try {
                navScroller.scrollTo({
                    left:     scrollOffset,
                    behavior: 'smooth'
                });
            } catch (e) {
                navScroller.scrollLeft = scrollOffset;
            }
        }
        function run() {
            var hHeight      = header    ? header.offsetHeight    : 0;
            var sNav         = stk__nave ? stk__nave.offsetHeight : 0;
            var headerHeight = parseInt(hHeight) + parseInt(sNav) + 32;
            var scrollTop    = window.scrollY || window.pageYOffset;
            var activeIndex  = -1;
            var firstSectionTop   = getOffsetTop(sections[0]) - headerHeight;
            var lastSection       = sections[sections.length - 1];
            var lastSectionBottom = getOffsetTop(lastSection) + lastSection.offsetHeight - headerHeight;
            if (scrollTop < firstSectionTop) {
                clearAll();
                ticking = false;
                return;
            }
            if (scrollTop >= lastSectionBottom) {
                clearAll();
                ticking = false;
                return;
            }
            for (var i = 0; i < sections.length; i++) {
                var sectionTop = getOffsetTop(sections[i]) - headerHeight;
                if (scrollTop >= sectionTop) {
                    activeIndex = i;
                }
            }
            clearAll();
            if (activeIndex !== -1) {
                var targetVal  = sections[activeIndex].dataset.targetEl || null;
                var matchedNav = findNavMatch(targetVal);
                if (matchedNav) {
                    matchedNav.classList.add('active');
                    scrollToActiveNav(matchedNav);
                }
            }
            ticking = false;
        }
        window.addEventListener('scroll', function () {
            if (!ticking) {
                requestAnimationFrame(run);
                ticking = true;
            }
        }, { passive: true });
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(run, 150);
        }, { passive: true });
        run();
    };
    stickyNavBuildScroll();

    const removeAlreadyAddInRecomm = () => {
        document.querySelectorAll('.product_route_recommendations_item').forEach((tg) => {
            tg.classList.remove('hidden');
        });
        document?.querySelectorAll(`[js-cm-drawer-outer]`)?.forEach((el) => {
            const cartHaveItem = el.dataset.mappedVariantId;
            if (cartHaveItem && cartHaveItem.trim() !== '') {
                document?.querySelectorAll(`.product_route_recommendations_item[data-product-variant-id="${cartHaveItem}"]`)
                    ?.forEach((tg) => { 
                        tg?.classList?.add('hidden'); 
                    });
            }
        });
    }

    document.body.addEventListener('click', function (event) {
        const addButton = event.target.closest('[js-button-confiq-add]');
        if (addButton) {
            event.preventDefault();
            const mainItemOuter = addButton.closest('[js-main-item-outer]');
            const configOuter = addButton.closest('[js-button-confiq-outer]');
            if (mainItemOuter && configOuter) {
                configOuter.classList.add('active');
                if (typeof updCommItemAdd === 'function') updCommItemAdd(mainItemOuter);
            }
            return;
        }

        const plusButton = event.target.closest('[js-button-confiq-plus]');
        if (plusButton) {
            event.preventDefault();
            const mainItemOuter = plusButton.closest('[js-main-item-outer]');
            const qtyContainer = plusButton.closest('[js-button-confiq-qty]');
            if (mainItemOuter && qtyContainer) {
                const inputElm = qtyContainer.querySelector('[js-button-confiq-input]');
                let currentQty = parseInt(inputElm.textContent || "1", 10);
                currentQty = currentQty + 1;
                inputElm.innerHTML = currentQty;
                if (currentQty > 1) {
                    qtyContainer.querySelector('[js-button-confiq-remove]')?.classList.add('hidden');
                    qtyContainer.querySelector('[js-button-confiq-minus]')?.classList.remove('hidden');
                }
                if (typeof updCommItemAdd === 'function') updCommItemAdd(mainItemOuter);
            }
            return;
        }

        const minusButton = event.target.closest('[js-button-confiq-minus]');
        if (minusButton) {
            event.preventDefault();
            const mainItemOuter = minusButton.closest('[js-main-item-outer]');
            const qtyContainer = minusButton.closest('[js-button-confiq-qty]');
            if (mainItemOuter && qtyContainer) {
                const inputElm = qtyContainer.querySelector('[js-button-confiq-input]');
                let currentQty = parseInt(inputElm.textContent || "1", 10);
                currentQty = currentQty - 1;
                inputElm.innerHTML = currentQty;
                if (currentQty === 1) {
                    qtyContainer.querySelector('[js-button-confiq-remove]')?.classList.remove('hidden');
                    qtyContainer.querySelector('[js-button-confiq-minus]')?.classList.add('hidden');
                }
                if (typeof updCommItemRemove === 'function') updCommItemRemove(mainItemOuter, false);
            }
            return;
        }
        const removeButton = event.target.closest('[js-button-confiq-remove]');
        if (removeButton) {
            event.preventDefault();
            const mainItemOuter = removeButton.closest('[js-main-item-outer]');
            const configOuter = removeButton.closest('[js-button-confiq-outer]');
            if (mainItemOuter && configOuter) {
                configOuter.classList.remove('active');
                if (typeof updCommItemRemove === 'function') updCommItemRemove(mainItemOuter, false);
            }
            return;
        }
    });

    document?.querySelector('[js-drawer-communication-html]')?.addEventListener('click', (target) => {
        const removeBtn = target.target.closest('[js-cm-drawer-remove]');
        if (removeBtn) {
            target.preventDefault();
            const drawerItemRow = removeBtn.closest('[js-cm-drawer-outer]');
            if (drawerItemRow) {
                updCommItemRemove(drawerItemRow, true);
            }
        }
    });
    
    document?.querySelectorAll(`input[name="purchaseType"]`).forEach((input)=>{
        input?.addEventListener('change', (tg)=>{
            updPriceAllOverPSelBased(tg.currentTarget.value);
            updCommProgressBar();
            updCmDrawerUpsellMessage();
        })
    });

    document?.querySelector(`[js-main-button]`)?.addEventListener('click',(tg)=>{
        tg.preventDefault();
        if( tg.currentTarget.closest(`[js-cm-main-outer-stepper]`).querySelectorAll(`.for__step__second`).length > 0 ){
            tg.currentTarget.closest(`[js-cm-main-outer-stepper]`).querySelector(`.for__step__second`).classList.add('active');
            tg.currentTarget.closest(`[js-cm-main-outer-stepper]`).querySelector(`.for__step__one`).classList.add('hidden');
            document?.querySelector(`.twv__split___renders__drawer`)?.classList?.add(`stepper__procced`);
            removeAlreadyAddInRecomm();
        }
    });

    document?.querySelector(`[js-cm-recommend-back-process]`)?.addEventListener('click',(tg)=>{
        tg.preventDefault();
        if( tg.currentTarget.closest(`[js-cm-main-outer-stepper]`).querySelectorAll(`.for__step__one`).length > 0 ){
            tg.currentTarget.closest(`[js-cm-main-outer-stepper]`).querySelector(`.for__step__second`).classList.remove('active');
            tg.currentTarget.closest(`[js-cm-main-outer-stepper]`).querySelector(`.for__step__one`).classList.remove('hidden');
            document?.querySelector(`.twv__split___renders__drawer`)?.classList?.remove(`stepper__procced`);
        }
    });
    
    document?.querySelectorAll(`[js-mobile-cm-drawer-open]`)?.forEach((dw)=>{
        dw?.addEventListener('click',(tg)=>{
            tg?.preventDefault();
            if( window.screen.width < 750 ){
                document.body.classList.toggle('mobile_drawerVisible');
                document.querySelector(`.page-blury-overlay`).classList.toggle(`is-visible`);
            }
        });
    });

    if( document.querySelectorAll('.play_paused___action .action--pause').length > 0 ){
        document.querySelectorAll('.play_paused___action .action--pause').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
                target.preventDefault();
                target.currentTarget.classList.add('hidden');
                target.target.closest('[js-video-container]').querySelector('.action--play').classList.remove('hidden');
                target.target.closest('[js-video-container]').querySelector('video').pause();
            })
        });
        document.querySelectorAll('.play_paused___action .action--play').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
                target.preventDefault();
                target.currentTarget.classList.add('hidden');
                target.target.closest('[js-video-container]').querySelector('.action--pause').classList.remove('hidden');
                target.target.closest('[js-video-container]').querySelector('video').play();
            })
        });  
    }  

    if (document.querySelectorAll(`[js-finally-takeover-submit]`).length > 0) {
        document.querySelectorAll(`[js-finally-takeover-submit]`).forEach((el) => {
            el.addEventListener('click', (tg) => {
                tg.preventDefault();
                const stepperContainer = tg.target.closest(`[js-cm-main-outer-stepper]`);
                const submitButton = tg.currentTarget;
                submitButton.classList.add('loading');
                submitButton.disabled = true;
                let cartElement = document.querySelector("cart-drawer");
                if (cartElement) cartElement.enableLoading();

                const mappedElements = stepperContainer
                    .querySelector(`.for__step__one`)
                    .querySelector(`[js-drawer-communication-html]`)
                    .querySelectorAll(`[data-mapped-variant-id]`);
                const purchaseTypeInput = stepperContainer.querySelector('[name="purchaseType"]:checked');
                const isSubscription = purchaseTypeInput && purchaseTypeInput.value === 'purchaseTypeSubscription';
                let ParentBundleVariantID = stepperContainer.dataset.bundleMainId,
                    bundleProductSellingId = stepperContainer.dataset.sellingPlan,
                    bundleProductPlatformId = stepperContainer.dataset.bundleProductId, 
                    uniqID = new Date().getTime().toString(),
                    bundleID = getGuid(), 
                    mainProperties = {
                        _bundle_id: bundleID,
                        _bundle_parent: "true",
                        _uniq_id:uniqID
                    },  
                    ParentCartItem = {
                        id: ParentBundleVariantID,
                        quantity: 1,
                        selling_plan:bundleProductSellingId,
                        properties:mainProperties
                    };
                                                               
                const items = [];

                mappedElements.forEach((item, index) => {
                    const variantId  = item.dataset.mappedVariantId;
                    const sellingId  = item.dataset.mappedSellingId;
                    const dynamicBoxID = item.dataset.mappedDynamicboxId;
                    
                    const cartItem = {
                        id: variantId,
                        quantity: 1,
                    };

                    if (isSubscription) {
                        if (sellingId && sellingId.trim() !== '') {
                            cartItem.selling_plan = sellingId;
                        }
                        if (dynamicBoxID && dynamicBoxID.trim() !== '') {
                            cartItem.properties = {
                                _dynamicBoxId: dynamicBoxID,
                                _original_qty: 1,
                                _bundle_id: bundleID,
                                _is_byob_child: "true",
                                _is_onetime:"false"
                            };
                        }
                    } else {
                        if (dynamicBoxID && dynamicBoxID.trim() !== '') {
                            cartItem.properties = {
                                _dynamicBoxId: dynamicBoxID,
                                _original_qty: 1,
                                _bundle_id: bundleID,
                                _is_byob_child: "true",
                                _is_onetime:"true"
                            };
                        }
                    }
                    items.push(cartItem);
                });
                // items.push(ParentCartItem);

                if (items.length === 0) {
                    if (cartElement) cartElement.disableLoading();
                    submitButton.classList.remove('loading');
                    submitButton.disabled = false;
                    return;
                }
                
                const productShouldBe = {
                    items: items,
                    sections: cartElement ? cartElement.getSectionsToRender().map((section) => section.section) : [],
                    sections_url: window.location.pathname
                };

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(productShouldBe),
                    credentials: 'same-origin'
                })
                .then((response) => response.json())
                .then((parsedState) => {
                    if (cartElement && parsedState.sections) {
                        cartElement.renderContent(parsedState.sections);
                    }
                })
                .catch((e) => console.error(e))
                .finally(() => {
                    if (cartElement) {
                        cartElement.disableLoading();
                        cartElement.open();
                    }
                    submitButton.classList.remove('loading');
                    submitButton.disabled = false;
                    clearAllCommHTMLAndResetDashboard();
                });
            });
        });
    } 

})